import { createReducer, on } from "@ngrx/store";
import { UserModel } from "../../interfaces/user-model";
import { UserActions } from "../actions";

export interface UserState {
    user: UserModel | null;
    error: string | null;
    loading: boolean;
}

export const userFeatureKey = "user";

export const initialState: UserState = {
    user: null,
    error: null,
    loading: false,
};

export const userReducer = createReducer(
    initialState,
    on(
        UserActions.loadUser,
        (state): UserState => ({
            ...state,
            loading: true,
        }),
    ),
    on(
        UserActions.loadUserSuccess,
        (state, { user }): UserState => ({
            ...state,
            user,
            loading: false,
        }),
    ),
    on(
        UserActions.loadUserFailure,
        (state, { error }): UserState => ({
            ...state,
            error,
            loading: false,
        }),
    ),
    on(UserActions.clearUser, (): UserState => ({ ...initialState })),
);
